import { normaliseConfidence } from "./normaliserUtils";

export default function normaliseCompliance(data)
{
    if (!data)
    {
        return [];
    }

    let issueList = data;

    if (!Array.isArray(issueList) && Array.isArray(data.issues))
    {
        issueList = data.issues;
    }

    if (!Array.isArray(issueList) && Array.isArray(data.observations))
    {
        issueList = data.observations;
    }

    if (!Array.isArray(issueList))
    {
        return [];
    }

    return issueList.map(function(issue, index)
    {
        return {

            id:
                issue.id != null
                    ? issue.id
                    : index + 1,

            title:
                issue.title ||
                issue.name ||
                issue.type ||
                "Compliance Observation",

            category:
                issue.category ||
                "General",

            priority:
                issue.priority ||
                "Medium",

            confidence:
                normaliseConfidence(
                    issue.confidence
                ),

            observation:
                issue.observation ||
                issue.notes ||
                issue.description ||
                null,

            recommendation:
                issue.recommendation ||
                null,

            x:
                issue.x,

            y:
                issue.y,

            width:
                issue.width,

            height:
                issue.height

        };
    });
}